import BaseCookies from "js-cookie";

// the cookie name is defined by com.armus.hybrid.web.security.test.UserManagerServiceImpl.USER_COOKIE_NAME
export const USER_COOKIE_NAME = "web.security.test.user";

const Cookies = (function () {
    const delim = "/";
    const a = window.location.pathname.split(delim);
    a.pop();
    return BaseCookies.withAttributes({path: a.join(delim) + delim});
})();

export function readCookie() {
    let spec = Cookies.get(USER_COOKIE_NAME);
    while (spec && spec.indexOf("%") >= 0) {
        spec = decodeURIComponent(spec).trim();
    }
    return spec;
}

export function setCookie(spec) {
    Cookies.set(USER_COOKIE_NAME, encodeURIComponent(spec)
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29"));
}

export function clearCookie() {
    Cookies.remove(USER_COOKIE_NAME);
}



// WEBPACK FOOTER //
// ./app/lib/reauth/utils.js